import React, {useEffect, useState} from "react";
import {Competition} from "../../../../../types/eventTypes";
import {Box, FormControl} from "@mui/material";
import CustomAutoComplete from "../../../CommonComponents/CustomAutoComplete";
import {getCompetitionOptions} from "../../../../../queries/competitionQueries";
import {CONTENT_PRESET_LABEL} from "@/constants/globalConstants";
import {ActiveFilters, FilterOption} from "@/types/filterTypes";
import MatchDaySearch from "@/pages/custom-components/CommonComponents/SearchAutocomplete/MatchDaySearch";
import {useSelectedCard} from "@/contexts/SelectedCardContext";
import {PANEL_MODE} from "@/types/generic";

interface GoalParadeFiltersProps {
    competition: FilterOption,
    matchDay: FilterOption
    onCompetitionChange: (Competition: FilterOption | null) => void;
    onMatchDayChange: (matchDay: FilterOption | null) => void;
    disabled?: boolean;
    presetMode?: boolean;
}

const DEFAULT_APP_COMPETITION_NAME = (import.meta as any).env.VITE_CONTENT_CREATION_COMPETITION_NAME
const DEFAULT_APP_COMPETITION_SEASON = (import.meta as any).env.VITE_CONTENT_CREATION_COMPETITION_SEASON

const GoalParadeFilters: React.FC<GoalParadeFiltersProps> = ({matchDay, competition, onMatchDayChange, onCompetitionChange, disabled = false, presetMode = false}) => {
    const [competitions, setCompetitions] = useState<FilterOption[]>([]);
    const [matchDayFilters, setMatchDayFilters] = useState<ActiveFilters | undefined>();
    const { panelMode } = useSelectedCard()

    const loadCompetitionsOptions = async () => {
        const tempCompetitions = await getCompetitionOptions()
        setCompetitions(tempCompetitions);
        if (panelMode === PANEL_MODE.CREATE){
            const defaultCompetition = tempCompetitions.find(comp => {
                return comp.value.toLowerCase().includes(DEFAULT_APP_COMPETITION_NAME) && comp.value.toLowerCase().includes(DEFAULT_APP_COMPETITION_SEASON)
            })
            handleCompetitionChange(competition || defaultCompetition || tempCompetitions[0] || null)
        }
    }

    const handleCompetitionChange = (competition: FilterOption | null) => {
        if (competition === null){
            setMatchDayFilters(undefined)
        } else{
            setMatchDayFilters({competitionFilterValues: [competition]})
        }
        onCompetitionChange(competition)
    }

    useEffect(() => {
        if (competition === null){
            setMatchDayFilters(undefined)
        } else{
            setMatchDayFilters({competitionFilterValues: [competition]})
        }
    }, [competition]);

    useEffect(() => {
        if(!presetMode){
            loadCompetitionsOptions()
        }else{
            onCompetitionChange({id: CONTENT_PRESET_LABEL, value: CONTENT_PRESET_LABEL})
            onMatchDayChange({id: CONTENT_PRESET_LABEL, value: CONTENT_PRESET_LABEL})
        }
    }, []);

    return(
        <Box display={'flex'} flexDirection={'column'} gap={2}>
            <FormControl fullWidth>
                <CustomAutoComplete
                    label={"Competition"}
                    options={competitions}
                    value={competition}
                    onChange={(_: any, newValue: any) => handleCompetitionChange(newValue)}
                    customAutocomplete={false}
                    multiple={false}
                    labelField={'value'}
                    valueField={'id'}
                    //disabled={(disabled || presetMode)}
                    readOnly={(disabled || presetMode)}
                />
            </FormControl>
            <FormControl fullWidth>
                <MatchDaySearch
                    label={'Match Day'}
                    value={matchDay}
                    onChange={onMatchDayChange}
                    freeSolo={false}
                    additionalFilters={matchDayFilters}
                    //disabled={(disabled || presetMode)}
                    readOnly={(disabled || presetMode)}
                />
            </FormControl>
        </Box>

    )
}

export default GoalParadeFilters;
